export default __webpack_public_path__ + "static/media/mc_balance.9f2317d8.svg";